module.exports = __webpack_public_path__ + "img/female_icon.0419fade.svg";